const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPacker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "99.5 0 313 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m99.5 62.4 165 95.4V512l-165-95.4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#02a8ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.5 103.5 167.2 0v72.3l122.2 71.4v216.8l58 33c35.7 20.5 65.1 8.9 65.1-27.7V206c-.8-35.6-30.3-82-66-102.5",
    style: {
      fill: "#02a8ef"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacker);
export default __webpack_public_path__ + "static/media/packer.9e568e84392c36ec32c963e3f20425ea.svg";
export { ForwardRef as ReactComponent };